import { useState } from 'react'
import { AppDesignSettingsWrapper } from './AppDesign.styles'
import { useTranslation } from 'react-i18next';
import { SketchPicker } from 'react-color';
import { Box, Popover, Stack, Tooltip, Typography } from '@mui/material';
import { GeneralButton } from '../../../common/ui/GeneralButton';
import { Colorize, Delete, Replay } from '@mui/icons-material';

interface Props {
  isEditMode: boolean;
  isSaving: boolean;
  accentColor: string | null | undefined;
  onColorChange: (color: string) => void;
  onResetClick: () => void;
  onDeleteClick: () => void;
}

export const AppDesignColor = ({ isEditMode, isSaving, accentColor, onColorChange, onResetClick, onDeleteClick }: Props) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [displaySketchPicker, setDisplaySketchPicker] = useState(false);

    const handleOpenSketchPicker = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setDisplaySketchPicker(true);
    };

    const handleCloseSketchPicker = () => {
      setAnchorEl(null);
      setDisplaySketchPicker(false);
    };

    return (
      <AppDesignSettingsWrapper>
         <Stack spacing={2}>
            <Typography variant='h5'>
              {t("configurationPage.appDesign.companyColor")}
            </Typography>
            <Box>
              {accentColor 
                ? <Box sx={{ display:"flex", gap:"15px" }}>
                    <Box 
                      sx={{
                        backgroundColor: `${accentColor}`,
                        height: "1.5em",
                        width: "1.5em",
                        borderRadius: "5px",
                        border: "1px solid lightgrey"
                      }}
                    />
                    <Box>{accentColor}</Box>
                  </Box>
                : <Box>{t("configurationPage.appDesign.noColorPicked")}</Box>
              }
            </Box>
            {isEditMode && !isSaving &&
              <Stack direction="row" spacing={1}>
                <Popover 
                  open={displaySketchPicker} 
                  anchorEl={anchorEl}
                  onClose={handleCloseSketchPicker}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                  <SketchPicker
                    color={accentColor ?? undefined}
                    onChange={(c) => onColorChange(c.hex)}
                  />
                </Popover>
                <Tooltip title={t("buttons.select")}>
                  <GeneralButton appVariant="icon" onClick={handleOpenSketchPicker}>
                    <Colorize/>
                  </GeneralButton>
                </Tooltip>

                <Tooltip title={t("buttons.reset")}>
                  <GeneralButton appVariant="icon" onClick={onResetClick}>
                    <Replay/>
                  </GeneralButton>
                </Tooltip>

                <Tooltip title={t("buttons.delete")}>
                  <GeneralButton appVariant="icon" onClick={onDeleteClick}>
                    <Delete/>
                  </GeneralButton>
                </Tooltip>
              </Stack>
            }
        </Stack>
      </AppDesignSettingsWrapper>
    )
}